import { QueryClient } from '@tanstack/vue-query';

// QueryClient PARTAGÉ (singleton) — exporté pour pouvoir vider le cache serveur
// depuis un endroit non-composant (ex. le store auth, au changement de tenant
// en impersonation : sans ça, TanStack Query re-sert les données du tenant
// précédent, d'où le besoin d'un Ctrl+Shift+R).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
